import React, {Component} from "react"
import Column from "@amzn/meridian/column";
import AdtfDeviceOverviewContextProvider from "./context/AdtfDeviceOverviewContext";
import TabLayout, {NavigationRoutes} from "../../util/TabLayout";
import {ADTF_PULLMODE_ROUTE} from "../../util/RouteConstants";
import {ADTF_PULLMODE} from "../../util/Constants";

/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */

class AdtfPullModePage extends Component {
    render() {
        return (
            <Column>
                <AdtfDeviceOverviewContextProvider data={{assetSubtype: ADTF_PULLMODE}}>
                    <TabLayout routes={ADTF_PULLMODE_ROUTE} location={this.props.location} history={this.props.history}/>
                    <NavigationRoutes routes={ADTF_PULLMODE_ROUTE}/>
                </AdtfDeviceOverviewContextProvider>
            </Column>
        )
    }
}

export default AdtfPullModePage;



// WEBPACK FOOTER //
// ./src/components/devicemanagement/adtfdevice/AdtfPullModePage.js